import { render, staticRenderFns } from "./v-mainContent.vue?vue&type=template&id=c8bee250&"
import script from "./v-mainContent.vue?vue&type=script&lang=js&"
export * from "./v-mainContent.vue?vue&type=script&lang=js&"
import style0 from "./v-mainContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VFooter,VOverlay,VParallax})
